export enum PimEnvironment {
  ACC = 1,
  PRD = 2,
}
